import { Paper, Typography, Box, Button, TextField } from "@mui/material";
import { useStyles } from "./login-form-contents-styles";
import { Formik, Form, useField } from "formik";
import * as Yup from "yup";
import { useTheme } from "@mui/material/styles";
import { EmailOutlined, LockOutlined } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const IconContainer = (props) => {
  const classes = useStyles();

  return (
    <Paper className={classes.IconContainerBgPaper} elevation={0}>
      {props.children}
    </Paper>
  );
};

const CustomTextInput = ({ label, icon, ...props }) => {
  const classes = useStyles();
  // useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
  // which we can spread on <input>. We can use field meta to show an error
  // message if the field is invalid and it has been touched (i.e. visited)
  const [field, meta] = useField(props);
  return (
    <>
      <label className={classes.formLabel} htmlFor={props.id || props.name}>
        {label}
      </label>

      <Box className={classes.inputContainer}>
        <Box>{icon}</Box>{" "}
        <input
          className={classes.input}
          {...field}
          {...props}
          variant="outlined"
        />
      </Box>

      {meta.touched && meta.error ? (
        <div className={classes}>{meta.error}</div>
      ) : null}
    </>
  );
};

const CustomCheckbox = ({ children, ...props }) => {
  // React treats radios and checkbox inputs differently other input types, select, and textarea.
  // Formik does this too! When you specify `type` to useField(), it will
  // return the correct bag of props for you -- a `checked` prop will be included
  // in `field` alongside `name`, `value`, `onChange`, and `onBlur`
  const [field, meta] = useField({ ...props, type: "checkbox" });
  const classes = useStyles();

  return (
    <div>
      <label className={classes.formDesc}>
        <input type="checkbox" {...field} {...props} />
        {children}
      </label>
      {meta.touched && meta.error ? (
        <div className="error">{meta.error}</div>
      ) : null}
    </div>
  );
};

// And now we can use these
const LoginFormContents = () => {
  const navigate = useNavigate();

  const theme = useTheme();

  const onLoginClickHandler = (event) => navigate("/dashboard");

  const classes = useStyles();
  return (
    <>
      <Formik
        initialValues={{
          firstName: "",
          lastName: "",
          email: "",
          acceptedTerms: false, // added for our checkbox
          jobType: "", // added for our select
        }}
        validationSchema={Yup.object({
          password: Yup.string()
            .max(20, "Must be 20 characters or less")
            .required("Required"),
          email: Yup.string()
            .email("Invalid email address")
            .required("Required"),
          rememberPassword: Yup.boolean(),
          jobType: Yup.string()
            .oneOf(
              ["designer", "development", "product", "other"],
              "Invalid Job Type"
            )
            .required("Required"),
        })}
        onSubmit={(values, { setSubmitting }) => {
          setTimeout(() => {
            alert(JSON.stringify(values, null, 2));
            setSubmitting(false);
          }, 400);
        }}
      >
        <Form>
          <CustomTextInput
            label="Email Address"
            icon={<EmailOutlined />}
            name="email"
            type="email"
            placeholder="user@example.com"
          />

          <CustomTextInput
            icon={<LockOutlined color={theme.palette.primary.main} />}
            label="Password"
            name="password"
            type="password"
          />

          <Box m={3} />

          <Box
            mb={3}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <CustomCheckbox name="rememberPassword">
              Remember passwords
            </CustomCheckbox>

            <Button variant="text" className={classes.forgotPasswordTextBtn}>
              Forgot password
            </Button>
          </Box>

          <Button
            variant="contained"
            size="large"
            type="submit"
            className={classes.signInBtn}
            onClick={onLoginClickHandler}
          >
            Sign In
          </Button>

          <Typography className={classes.signInText}>Sign in with</Typography>

          <Box className={classes.IconContainerBgPaperBox}>
            <IconContainer>
              <EmailOutlined />
            </IconContainer>
            <IconContainer>
              {" "}
              <EmailOutlined />{" "}
            </IconContainer>
            <IconContainer>
              {" "}
              <EmailOutlined />{" "}
            </IconContainer>
            <IconContainer>
              {" "}
              <EmailOutlined />{" "}
            </IconContainer>
          </Box>

          <Box className={classes.bottomTextBox}>
            <Typography>Don't have account? </Typography>
            <Box mx={1} />
            <Button className={classes.createAccountBtn} variant={"text"}>
              Create Account
            </Button>
          </Box>
        </Form>
      </Formik>
    </>
  );
};

export default LoginFormContents;
